// Claude: Admin AI KB Common — ai_common type entries, applicable to both buyers and sellers 25-03-2026
import React from "react";
import KnowledgeBasePage from "./KnowledgeBasePage";

const HINT = `Entries here are shown to BOTH buyers and sellers in AI chat. To show a tappable button, wrap text with <button> tags. Example: <button>Know more about AFTR</button>`;

const AIKnowledgeCommon = () => <KnowledgeBasePage type="ai_common" title="AI Knowledge Base — Common" hint={HINT} />;

export default AIKnowledgeCommon;
